module.exports = __webpack_public_path__ + "static/media/JP_NS_EYELASHES04.e4e2a910.jpg";